<template>
  <div class="good-detail">
    <md-card>
      <md-card-header>
        <div class="md-title">{{detailInfo.name2}}</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <!-- 图片+亮点简介 -->
          <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">
            <!-- 图片，暂时一张 -->
            <div>
              <img
                :src="detailInfo.image"
              >
            </div>
            <div>
              <h1>亮点推荐</h1>
              <div>（4人豪华套房+早餐4位+温泉4位+大餐庙会4位+单车券+烟花券+游戏券）（1张1.8中式大床+2张95公分榻榻米铺在客厅）</div>
            </div>
          </div>
          <!-- 时间选择和价格 -->
          <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">
            <!-- 价格 -->
            <div class="layout-right">
              <div class="price_info bg_gray">
                <div>
                  促销价：
                  <span class="price_label">￥</span>
                  <span class="price">1580</span>起/份（2成人）
                </div>
                <div>优惠信息：立减</div>
              </div>
              <div class="extra_info">
                <div>
                  <span>特色服务：</span>
                  <span class="margin-15">
                    <el-tag type="warning">游记有奖</el-tag>
                  </span>
                  <span class="margin-15">
                    <el-tag type="warning">点评送积分</el-tag>
                  </span>
                </div>
              </div>
              <div>
                <date-picker v-model="chooseDate" @input="value => chooseDate = value"></date-picker>
              </div>
              <div class="order_preview">
                <!-- 入住日期 -->
                <div class="order_preview_item" v-for="(item) in chooseDate" :key="item">
                  <span>入住日期：</span>

                  <span>
                    <good-date-price-show :date="item" :price="`1400元`"></good-date-price-show>
                  </span>

                  <el-input-number v-model="chooseDateAndCount[item]" :min="1"></el-input-number>
                </div>
                <div class="order_preview_buttons">
                  <span class="total_price">总价：XXXX</span>
                  <div>
                    <md-button class="md-raised md-primary">加入购物车</md-button>
                    <md-button class="md-raised md-accent" @click="doPresetOrder">立即预定</md-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
      <div v-html="detailRender" class="detail-render">
      </div>
      <!-- <md-card-actions>
        <md-button>Action</md-button>
        <md-button>Action</md-button>
      </md-card-actions>-->
    </md-card>

  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker";
import GoodDatePriceShow from "./GoodDatePriceShow";
import { getGoodDetail,getGoodDesc } from "@/api/good";
export default {
  name: "good-detail",
  components: {
    DatePicker,
    GoodDatePriceShow
  },
  props: {
    no: Number
  },
  data() {
    return {
      chooseDate: [],
      chooseDateAndCount: {},
      detailRender:'',
      detailInfo:{}
    };
  },
  watch: {
    chooseDate: {
      immediate: true,
      deep: true,
      handler: function(val) {
        val.forEach(ele => {
          if (!this.chooseDateAndCount.hasOwnProperty(ele)) {
            this.$set(this.chooseDateAndCount, ele, 1);
          }
        });
      }
    }
  },
  created() {
    this.getGoodDetailByGoodNo();
  },
  methods: {
    getGoodDetailByGoodNo() {
      getGoodDetail(465).then(res => {
        this.detailInfo=res.data.data
        getGoodDesc(res.data.data.description).then(res=>{
          this.detailRender = res.data
        })
      })
    },
    doPresetOrder() {
      this.$router.push("/preset");
    }
  }
};
</script>

<style lang="scss" scoped>
.bg_gray {
  background: #f3f3f3;
  height: 100px;
}
.margin-15 {
  margin: 15px 5px;
}
.good-detail {
  width: 80vw;
  margin: 20px auto;
  min-width: 1120px;
  .layout-right {
    padding: 30px;
  }
  .price_info {
    padding: 20px;
    font-size: 17px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 40px;
    .price_label {
      font-size: 16px;
      color: red;
    }
    .price {
      font-size: 32px;
      color: red;
    }
  }
  .extra_info {
    border-bottom: 2px dotted #d3d3d3;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    padding-bottom: 10px;
  }
  .order_preview {
    margin: 20px 0;
    border: 2px solid rgb(255, 92, 93);
    display: flex;
    flex-direction: column;
    width: 100%;
    .order_preview_item {
      width: 100%;
      padding: 5px 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .order_preview_buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      .total_price {
        font-size: 24px;
        color: red;
      }
    }
  }
  .detail-render{
    padding: 10px 10px;
    text-align:left;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 1029px){
  .detail-render{
    padding: 20px 50px;
    text-align:left;
    margin: 0 auto;
  }
}
</style>

